import * as RBReportConstants from "./RBReportConstants";
import {
    STATUS_FAILURE,
    STATUS_SUCCESS,
    STATUS_PENDING,
} from "Common/constants/commonConstants";
const assign = Object.assign || require("object.assign");


const initialState = {
    isLoading: false,
    reports: [],
    error: null,
    isError: false
};

export default function RBReportReducer(state = initialState, action) {
    switch (action.type) {
        case RBReportConstants.FETCH_RB_REPORTS_REQUEST:
            return {
                ...state,
                isLoading: STATUS_PENDING,
                error: "",
                isError: false
            };
        case RBReportConstants.FETCH_RB_REPORTS_SUCCESS:
            return {
                ...state,
                isLoading: STATUS_SUCCESS,
                reports: action.payload?.result?.rbReport,
                error: "",
                isError: false
            };
        case RBReportConstants.FETCH_RB_REPORTS_ERROR:
            return {
                ...state,
                reports: [],
                isLoading: STATUS_FAILURE,
                error: action.payload,
                isError: true
            };

        case RBReportConstants.CLOSE_ERROR_MESSAGE_POPUP:
            return {
                ...state,
                isError: false,
                error: "",
            };

        default:
            return state;
    }
}
